import { render, staticRenderFns } from "./DialerPopOver.vue?vue&type=template&id=0583870d&scoped=true"
import script from "./DialerPopOver.vue?vue&type=script&lang=js"
export * from "./DialerPopOver.vue?vue&type=script&lang=js"
import style0 from "./DialerPopOver.vue?vue&type=style&index=0&id=0583870d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0583870d",
  null
  
)

export default component.exports